//@vendor
const React = require('react');
//@commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');

const MyProfileSecurityKitChangeErrorEnd = () => {
    const exitLink = `/myProfile/keys`;
    const goBackButtonLabel = formatText('securityKit-errorLink').toUpperCase();
    const title = formatText('securityKit-errorTitle');
    const goBackButton = {
        label: goBackButtonLabel,
        url: exitLink
    }

    return (
        <div>
            <WizardError
                errorMessage={title}
                mainButton={goBackButton}
            >
                <p>
                    <FormattedText value="securityKit-errorSubTitle" />
                </p>
            </WizardError>
        </div>
    )
};

module.exports = MyProfileSecurityKitChangeErrorEnd;
